/**
 * @en The UIEvent class is used to define the event types of UI component classes.
 * @zh UIEvent 类用来定义UI组件类的事件类型。
 */
export class UIEvent {
    /**
     * @en Display prompt information.
     * @zh 显示提示信息。
     */
    static SHOW_TIP: string = "showtip";
    /**
     * @en Hide prompt information.
     * @zh 隐藏提示信息。
     */
    static HIDE_TIP: string = "hidetip";
}